export default "__VITE_ASSET__C82phbF8__"